
import {Select} from "./Select.js";

export class CompanyCategorySelect extends Select {
    template() {
        const {addClassName = ""} = this.$props;
        return `
            <i class="sign-icons-arrow-mini"></i>
              <select id="joinTeamSector" class="join-select-input ${addClassName}" 
                  data-required-yn="Y" 
                  data-empty-msg="${i18next.t(login.selectCompanyCategory)}">>
                    ${this.getOptionsTemplate()}
              </select>
              <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
              </p>`
    }
    getQuerySelectorOfSelect() {
        return `#joinTeamSector`
    }

    getOptionsDataArr() {
        return[
            {value: "", text: `${i18next.t(login.selectCompanyCategory)}`},
            {value: "Produce", text: `${i18next.t(login.category.produce)}`},
            {value: "IT", text: `${i18next.t(login.category.tech)}`},
            {value: "Franchise", text: `${i18next.t(login.category.franchise)}`},
            {value: "Logistics", text: `${i18next.t(login.category.logistics)}`},
            {value: "Entertain", text: `${i18next.t(login.category.entertain)}`},
            {value: "Public", text: `${i18next.t(login.category.public)}`},
            {value: "Construct", text: `${i18next.t(login.category.construct)}`},
            {value: "Tax", text: `${i18next.t(login.category.tax)}`},
            {value: "Medical", text: `${i18next.t(login.category.medical)}`},
            {value: "Finance", text: `${i18next.t(login.category.finance)}`},
            {value: "Association", text: `${i18next.t(login.category.association)}`},
            {value: "Research", text: `${i18next.t(login.category.research)}`},
            {value: "PrimaryIndustry", text: `${i18next.t(login.category.primaryIndustry)}`},
            {value: "etc", text: `${i18next.t(login.category.etc)}` },
        ];
    }
}